<template>
	<div class="hello">
		<div style="height: 100%;width: 100%;">
			<div style="height: 70px; background-color: #282828;top: 0px;position:fixed;width: 100%;z-index: 9999;">
				<div class="center" style="height: 100%; color: white;">
					<ul class="uls">
						<li class="lis">
							<router-link to="mobile" >
								<img src="../../public/helloworld/LGOO.png" style="height: 100%;width: 90px;padding-left: 40px;"/>
							</router-link>
						</li>
						<li class="lis">
							<div @click="open" id="1">
								<p class="title">
									{{ $t('lang.Best_sellers')}}
								</p>
								
							</div>
						</li>
						<li class="lis">
							<div @click="open" id="2">
								<p class="title">
									{{ $t('lang.Business')}}
								</p>
								
							</div>
						</li>
						<li class="lis">
							<div @click="open" id="4">
								<p class="title">
									{{ $t('lang.Support')}}
								</p>
								
							</div>
						</li>
						<li class="lis" >
							<div @click="open" id="5">
								<p class="title">
									{{ $t('lang.About_us')}}
								</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
			
			<div @click="close">
				<div v-show="activeIndex=='1'" class="center title2">
					<div class = "size2" >
						<ul class="ultransverse" style="margin: 0;padding: 0;">
							<router-link to="Sterilization-robot1">
								<li class="litransverse hov">
									<p class="titletext">{{ $t('lang.Spray_disinfection')}}&emsp;{{ $t('lang.Robot')}}</p>
								</li>
							</router-link><br />
							<router-link to="UVC-robot1">
								<li class="litransverse hov">
									<p class="titletext">{{ $t('lang.UVC_disinfection')}}&emsp;{{ $t('lang.Robot')}}</p>
								</li>
							</router-link><br />
							
							<router-link to="Sterilizer1">
								<li class="litransverse hov">
									<p class="titletext">{{ $t('lang.homedis24')}}</p>
								</li>
							</router-link><br />
							
							<router-link to="Receptionist-robot1">
								<li class="litransverse hov">
									<p class="titletext">
										{{ $t('lang.Receptionist')}}&emsp;{{ $t('lang.Robot')}}
									</p>
								</li>
							</router-link>
							<br />
							
							<router-link to="Companion-robot1">
								<li class="litransverse hov">
									<p class="titletext" >
										{{ $t('lang.Companion')}}&emsp;{{ $t('lang.Robot')}}
									</p>
								</li>
							</router-link>
							
						</ul>
					</div>
				</div>
				<div v-show="activeIndex=='2'" class="center title2">
					<div class = "size2">
						<ul class="ultransverse" style="margin: 0;padding: 0;">
							<router-link to="buy1">
								<li class="litransverse hov">
									<p class="titletext">{{ $t('lang.Buy')}}</p>
								</li>
							</router-link>
							<br />
							<router-link to="buy1">
								<li class="litransverse hov">
									<p class="titletext">{{ $t('lang.Become_an_agent')}}</p>
								</li>
							</router-link>
							<br />
							<router-link to="cooperate1">
								<li class="litransverse hov">
									<p class="titletext">
										{{ $t('lang.Our_customers')}}
									</p>
								</li>
							</router-link>
						</ul>
					</div>
				</div>
				<div v-show="activeIndex=='4'"  class="center title2">
					<div class = "size2">
						<ul class="ultransverse" style="margin: 0;padding: 0;">
							<router-link to="aftersale1">
								<li class="litransverse hov">
									<p class="titletext">{{ $t('lang.After_sale_service')}}</p>
								</li>
							</router-link>
						</ul>
					</div>
				</div>
				<div v-show="activeIndex=='5'" class="center title2">
					<div class = "size2">
						<ul class="ultransverse" style="margin: 0;padding: 0;">
							<router-link to="profile1">
								<li class="litransverse hov">
									<p class="titletext">{{ $t('lang.Company_profile')}}</p>
								</li>
							</router-link>
							<br />
							<router-link to="dynamic1">
								<li class="litransverse hov">
									<p class="titletext">{{ $t('lang.News')}}</p>
								</li>
							</router-link>
							<br />
							
							<router-link to="contact1">
								<li class="litransverse hov">
									<p class="titletext">{{ $t('lang.Contact_us')}}</p>
								</li>
							</router-link>
							<br />
						</ul>
					</div>
				</div>	
			
				<div style="padding-top: 70px;padding-left: 0px;padding-bottom: 0px;padding-right: 0px;">
					<router-view style="width: 100%;"></router-view>
				</div>
				
				<div class="footer center ">
					<div style="width: 90%;" class="center_sun">
						<h2 style="color: gray;">{{ $t('lang.Contact1')}}</h2>
						<p style="text-align: left;margin-top: 40px;" class="footertext">
							{{ $t('lang.Contact2')}}<br/><br/>
							{{ $t('lang.Contact3')}}
							<a v-show="this.$i18n.locale == 'zh'" href="tel:075523226813">
								<van-icon name="phone-o" color="#1989fa" size="18"/>
							</a>
							<a v-show="this.$i18n.locale == 'en'" href="tel:86075523226813">
								<van-icon name="phone-o" color="#1989fa" size="18"/>
							</a>
							<br/><br/>
							{{ $t('lang.Contact4')}}
							<a v-show="this.$i18n.locale == 'zh'" href="tel:15986723663">
								<van-icon name="phone-o" color="#1989fa" size="18"/>
							</a>
							<a v-show="this.$i18n.locale == 'en'" href="tel:8613421340682">
								<van-icon name="phone-o" color="#1989fa" size="18"/>
							</a>
							<br/><br/>
							{{ $t('lang.Contact5')}}<br/><br/>
							<span class="footertext" v-show="this.$i18n.locale == 'zh'">
								{{ $t('lang.Contact6')}}<br/><br/>
							</span>
							{{ $t('lang.Contact7')}}<br/><br/>
							{{ $t('lang.Contact8')}}<br/><br/>
							<span class="footertext" v-show="this.$i18n.locale == 'zh'">
								{{ $t('lang.Contact9')}}<br/><br/>
							</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeIndex: '',
			tel:'',
		};
	},
	methods: {
		// handleSelect(key, keyPath) {
		// 	console.log(key, keyPath);
		// },
		open(event){
			if(this.activeIndex == event.currentTarget.id){
				this.activeIndex = '';
			}
			else{
				this.activeIndex = event.currentTarget.id;
			}
		},
		changeLaguages () {
			// console.log(this.$i18n.locale)
			let lang = this.$i18n.locale === 'zh' ? 'en' : 'zh'
			this.$i18n.locale = lang
		},
		close(){
			this.activeIndex = ''
		},
		
	},
	created:function() {
		this.$router.push('mobile');
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	
	
.footertext{
	color: gray;
	font-size: 14px;
}

::-webkit-scrollbar{
	width:0;
}
	
.title{
	height: 40px;text-align: center;
	width: 100%; line-height: 50px;
	margin: 0;padding: 0px 30px;white-space:nowrap;
	
}

.title2{
	position: fixed;
	z-index: 888;
	left:0; right:0; top:70px;
	margin:auto;
	
}

.size2{
	width: 60%;
	background-color: #121210;
}

.titletext{
	text-align: center;margin: 5px;padding: 0;
}

h3 {
  margin: 40px 0 0;
}

a {
  color: #42b983;
}
.hello{
  height: 100%;
}
p{
	color: white;
	font-size: 20px;
}
.absol{
	position:fixed;
	z-index: 9999;
	top: 250px;
	right: 0px;
}

.bottomfont{
	color: gray;
	font-size: 16px;
}





.button {
	height: 30px;
	width: 100px;
	display: inline-block;
	font-size: 20px;
	cursor: pointer;
	text-align: center;   
	text-decoration: none;
	outline: none;
	color: #fff;
	background-color: #5500ff;
	border: none;
	border-radius: 15px;
	box-shadow: 0 4px #999;
}

.button:hover {background-color: #00aaff}

.button:active {
	background-color: #00aa00;
	box-shadow: 0 5px #666;
	transform: translateY(2px);
}



.hov:hover{
	background-color: grey;
	width: 100;
}

.hov{
	width: 100%;
}

.uls {
  display: flex;
  overflow-x: scroll;
}
.lis{
  white-space: nowrap;
}

</style>
